module.exports = __webpack_public_path__ + "img/x10.80565069.jpg";